import { render } from "./LessonsVideo.vue?vue&type=template&id=358089cd&scoped=true"
import script from "./LessonsVideo.vue?vue&type=script&lang=js"
export * from "./LessonsVideo.vue?vue&type=script&lang=js"

import "./LessonsVideo.vue?vue&type=style&index=0&id=358089cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358089cd"]])

export default __exports__